import gql from 'graphql-tag';
import {
  AddressComponentOverride,
  AuditCheckboxComponentOverride,
  AuditTagComponentOverride,
  AuditTextComponentOverride,
  CombinedTagsComponentOverride,
  DateComponentOverride,
  DateRangeComponentOverride,
  EmailComponentOverride,
  EntityBatchComponentOverride,
  FileComponentOverride,
  GeolocationComponentOverride,
  InputButtonComponentOverride,
  NumberComponentOverride,
  PersonComponentOverride,
  ReferencedInComponentOverride,
  RelatedCardComponentOverride,
  RelatedCardLookupComponentOverride,
  ScheduledAutomationComponentOverride,
  SignatureComponentOverride,
  StaticTextComponentOverride,
  SubformComponentOverride,
  TagComponentOverride,
  TextComponentOverride,
  TimeTrackerComponentOverride,
  TodoComponentOverride,
  UrlComponentOverride,
} from './component';
import { FilterOneOfFields } from './filter';

export const FilterByComponent = gql`
  fragment FilterByComponent on FilterByComponentObject {
    componentId
    scalarKey
    value {
      ...FilterOneOfFields
      matchesRelatedEntity {
        filterByComponent {
          componentId
          scalarKey
          value {
            ...FilterOneOfFields
            matchesRelatedEntity {
              filterByComponent {
                componentId
                scalarKey
                value {
                  ...FilterOneOfFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${FilterOneOfFields}
`;

export const CollectionCriteria = gql`
  fragment CollectionCriteria on CollectionCriteriaObject {
    sortByComponents {
      componentId
      direction
    }
    filterByComponents {
      ...FilterByComponent
    }
    groups {
      filterByComponents {
        ...FilterByComponent
      }
    }
  }
  ${FilterByComponent}
`;

export const ViewTemplate = gql`
  fragment ViewTemplate on ViewTemplate {
    id
    createdAt
    updatedAt
    name
    type
    subtype
    customSortingEnabled
    calendarDateComponentId
    calendarHideWeekends
    checklistTagComponentId
    treeParentComponentId
    isPublic
    defaultHiddenComponents
    defaultHiddenLabels
    defaultReadonlyComponents
    displayInCards
    displayLegacyRecurrence
    displayLegacyReminders
    displayLegacyStatusButton
    displayMessageThread
    summarizeReadonlyTags
    sortOrder
    customSortingEnabled
    workflowTemplateId
    collectionCriteria {
      ...CollectionCriteria
    }
    componentsViewOptions {
      componentId
      isHidden
      overrides {
        ...AddressComponentOverride
        ...AuditCheckboxComponentOverride
        ...AuditTagComponentOverride
        ...AuditTextComponentOverride
        ...CombinedTagsComponentOverride
        ...DateComponentOverride
        ...DateRangeComponentOverride
        ...EmailComponentOverride
        ...EntityBatchComponentOverride
        ...FileComponentOverride
        ...GeolocationComponentOverride
        ...InputButtonComponentOverride
        ...NumberComponentOverride
        ...PersonComponentOverride
        ...RelatedCardComponentOverride
        ...RelatedCardLookupComponentOverride
        ...ReferencedInComponentOverride
        ...ScheduledAutomationComponentOverride
        ...SignatureComponentOverride
        ...StaticTextComponentOverride
        ...SubformComponentOverride
        ...TagComponentOverride
        ...TextComponentOverride
        ...TodoComponentOverride
        ...TimeTrackerComponentOverride
        ...UrlComponentOverride
      }
    }
  }
  ${CollectionCriteria}
  ${FilterByComponent}
  ${AddressComponentOverride}
  ${AuditCheckboxComponentOverride}
  ${AuditTagComponentOverride}
  ${AuditTextComponentOverride}
  ${CombinedTagsComponentOverride}
  ${DateComponentOverride}
  ${DateRangeComponentOverride}
  ${EmailComponentOverride}
  ${EntityBatchComponentOverride}
  ${FileComponentOverride}
  ${GeolocationComponentOverride}
  ${InputButtonComponentOverride}
  ${NumberComponentOverride}
  ${PersonComponentOverride}
  ${RelatedCardComponentOverride}
  ${RelatedCardLookupComponentOverride}
  ${ReferencedInComponentOverride}
  ${ScheduledAutomationComponentOverride}
  ${SignatureComponentOverride}
  ${StaticTextComponentOverride}
  ${SubformComponentOverride}
  ${TagComponentOverride}
  ${TextComponentOverride}
  ${TodoComponentOverride}
  ${TimeTrackerComponentOverride}
  ${UrlComponentOverride}
`;

export const ViewTemplateLayoutSection = gql`
  fragment ViewTemplateLayoutSection on ViewTemplateLayoutSection {
    id
    type
    title
    isCollapsed
    componentIds
    columnCount
  }
`;

export const ViewTemplateLayoutComponent = gql`
  fragment ViewTemplateLayoutComponent on ViewTemplateLayoutComponent {
    id
    type
    componentId
  }
`;

export const ViewTemplateLayoutText = gql`
  fragment ViewTemplateLayoutText on ViewTemplateLayoutText {
    id
    type
    text
  }
`;

export const ViewTemplateLayoutImage = gql`
  fragment ViewTemplateLayoutImage on ViewTemplateLayoutImage {
    id
    type
    images {
      contentType
      height
      name
      url
      width
    }
  }
`;

export const ViewTemplateLayoutVideo = gql`
  fragment ViewTemplateLayoutVideo on ViewTemplateLayoutVideo {
    id
    type
    contentType
    name
    url
    metadata {
      thumbnailUrl
    }
  }
`;

export const ViewTemplateLayout = gql`
  fragment ViewTemplateLayout on ViewTemplateLayout {
    id
    items {
      ... on ViewTemplateLayoutSection {
        ...ViewTemplateLayoutSection
      }
      ... on ViewTemplateLayoutComponent {
        ...ViewTemplateLayoutComponent
      }
      ... on ViewTemplateLayoutText {
        ...ViewTemplateLayoutText
      }
      ... on ViewTemplateLayoutImage {
        ...ViewTemplateLayoutImage
      }
      ... on ViewTemplateLayoutVideo {
        ...ViewTemplateLayoutVideo
      }
    }
  }
  ${ViewTemplateLayoutSection}
  ${ViewTemplateLayoutComponent}
  ${ViewTemplateLayoutText}
  ${ViewTemplateLayoutImage}
  ${ViewTemplateLayoutVideo}
`;
